import axios from 'axios';
import type { XWorksheet } from '@/models/xworksheet';
import type { XLesson } from '@/models/xlesson';

class XWorksheetWebservice {
    public getById(worksheetId: number) {
        return axios.get<XWorksheet>('/xworksheets/getById', {
            params: {
                worksheetId,
            },
        });
    }

    public store(xWorksheet: XWorksheet, xLessons: XLesson[]) {
        return axios.post('/xworksheets/store', {
            projectId: xWorksheet.project.id,
            xProcessId: xWorksheet.x_process.id,
            xLessons,
        });
    }

    public update(xWorksheet: XWorksheet, xLessons: XLesson[]) {
        return axios.post('/xworksheets/update', {
            worksheetId: xWorksheet.id,
            xLessons,
        });
    }

    public remove(xWorksheet: XWorksheet) {
        return axios.post('/xworksheets/remove', {
            id: xWorksheet.id,
        });
    }
}

export const xWorksheetWebservice = new XWorksheetWebservice();
